import { ListRawCarData, RawCarData } from '../../../api/cars'

// TODO: временный костыль, нужно будет ИЛИ перевести деталку на использование ListRawCarData и избавиться от старого RawCarDatа
// ИЛИ на бэке сделать чтобы роут тачек отдавал RawCarData а не ListRawCarData
export const listRawCarDataToRawCarData = (carData: ListRawCarData): RawCarData => {
  const {
    attributes: { labels, ...restAttributes },
    ...rest
  } = carData

  return {
    ...restAttributes,
    labels: labels.map((label) => ({
      ...label,
      tooltip: label.tooltip.value,
      text: label.text.value,
      hidden: label.hidden
    })),
    productType: carData.attributes.is_new ? 'new' : 'used',
    has_video: carData.attributes.has_video,

    ...rest
  }
}
